/**
 * Constants for RiseAI Chat component
 */

export const DRAWER_WIDTH = '1200px';

export const CATEGORIES = ['All', 'Vulnerabilities', 'SBOM', 'Licenses', 'Cryptography', 'Binaries', 'Secrets'];

export const RISE_AI_APP_NAME = 'rise_ai_llm_agent';

export const RISE_AI_STATUS = {
  UNSPECIFIED: 'UNSPECIFIED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
  ELIGIBLE: 'ELIGIBLE'
};

/**
 * ADK Event Types (normalized to match AG-UI-like structure)
 */
export const ADK_EVENT_TYPES = {
  TEXT_MESSAGE_START: 'TEXT_MESSAGE_START',
  TEXT_MESSAGE_CONTENT: 'TEXT_MESSAGE_CONTENT',
  TEXT_MESSAGE_END: 'TEXT_MESSAGE_END',
  TOOL_CALL_START: 'TOOL_CALL_START',
  TOOL_CALL_RESULT: 'TOOL_CALL_RESULT',
  TOOL_CALL_END: 'TOOL_CALL_END',
  RUN_FINISHED: 'RUN_FINISHED',
  ERROR: 'ERROR',
  UNKNOWN: 'UNKNOWN'
};

/**
 * ADK Author constants
 * These represent the different agents/authors that can process events in the ADK system
 * Currently only includes authors that are actively used in adkEventParser.js
 */
export const ADK_AUTHORS = {
  // Retrieval flow agents
  DATA_ROUTER: 'data_router',
  PRESENTER: 'presenter',
  
  // Main orchestration agents
  METADATA_ANSWER: 'metadata_answer',
  DIRECT_ANSWER: 'direct_answer',
  
  // Vulnerability remediation flow agents
  REMEDIATION_PROPOSER: 'remediation_proposer',
  REMEDIATION_CONFIRMATION: 'remediation_confirmation',
  REMEDIATION_SUMMARY: 'remediation_summary',

  // Component-level remediation flow agents (same behavior as remediation_* authors)
  COMPONENT_REMEDIATION_PROPOSER: 'component_remediation_proposer',
  COMPONENT_REMEDIATION_CONFIRMATION: 'component_remediation_confirmation',
  COMPONENT_REMEDIATION_SUMMARY: 'component_remediation_summary',

  // Session settings agents
  SESSION_SETTINGS: 'session_settings'
};

/**
 * Feedback reasons for negative feedback
 */
export const FEEDBACK_REASONS = {
  NOT_ACCURATE: 'Not accurate',
  TOO_VAGUE: 'Too vague / not actionable',
  TOO_VERBOSE: 'Too verbose',
  MISSING_CONTEXT: 'Missing important context',
  MISUNDERSTOOD: 'Misunderstood my question',
  OTHER: 'Other'
};
